export default __webpack_public_path__ + "static/media/Menu-dots.a4081f35.svg";